(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Protein", [], factory);
	else if(typeof exports === 'object')
		exports["Protein"] = factory();
	else
		root["Protein"] = factory();
})(window, function() {
return 